import { WaitlistPage } from '@features/onboarding/components/WaitlistPage';
import { createFileRoute } from '@tanstack/react-router';

// Outside `_authenticated`: its disqualifiedAt guard would redirect right back here. WaitlistPage does its own auth checks.
export const Route = createFileRoute('/waitlist')({ component: WaitlistPage });
